import { lazy } from 'react'
import { RouteConfig } from 'react-router-config'
import { Redirect } from 'react-router-dom'

// import { get } from '@/utils/fetch'
import { /* isBefore901, */ isBefore909, isBefore915 } from '@/pages/hmt/utils'
import ReservationV2Routes from './reservation-v2'

const ReservationLayout = lazy(() => import('@/pages/hmt/reservation/layout'))
const OfficialLayout = lazy(() => import('@/pages/hmt/official/layout'))
const PcAds1 = lazy(() => import('@/pages/hmt/pc-ads/pc-ads1'))
const PcAds2 = lazy(() => import('@/pages/hmt/pc-ads/pc-ads2'))
const PcAds3 = lazy(() => import('@/pages/hmt/pc-ads/pc-ads3'))
const HmtAnniversary2023FirstHalf = lazy(
  () => import('@/pages/hmt/activities/anniversary/2023first-half')
)
const HmtSakura2024 = lazy(() => import('@/pages/hmt/activities/sakura2024'))
const HmtMSakura2024 = lazy(() => import('@/pages/hmt/activities/sakura2024/m-site'))
const spyFamily = lazy(
  () => import('@/pages/hmt/activities/spyFamily')
)
const NewGroupReservation = lazy(
  () => import('@/pages/hmt/activities/newGroup')
)
const NewGroupReservation2 = lazy(
  () => import('@/pages/hmt/activities/newGroup2')
)
const NewGroupReservation3 = lazy(
  () => import('@/pages/hmt/activities/newGroup3')
)

const Guild = lazy(() => import('@/pages/hmt/activities/guildhall'))

const Radiant = lazy(() => import('@/pages/hmt/activities/radiant'))
// const generateRouter = get('/api/homepage')
//   .then((res) => {
//     /** 获取服务端时间 */
//     const currentTime = (res as any).current_time
//     if (typeof currentTime === 'number') {
//       window.serverTimestamp = currentTime * 1000
//     } else {
//       window.serverTimestamp = +new Date()
//     }

/**
 * TODO:
 * 打开可看效果
 * 901上线应该打开，或者删掉
 */
const routerIntercepterEnabled = true

const routes: RouteConfig[] = [
  isBefore915()
    ? {
      path: '/',
      exact: true,
      render: () => <Redirect to="/pc-site/home" />,
    }
    : {
      path: ['/', '/pc-site/home', '/m-site/home'],
      exact: true,
      render: () => <Redirect to="/pc-site/official/home" />,
    },

  /* 正式官網路由 */
  {
    path: '/activity/spy-family-reservation',
    component: spyFamily,
  },
  // {
  //   path: '/activity/new-group-reservation2',
  //   component: NewGroupReservation2,
  // },
  {
    path: '/activity/sakura2024',
    component: HmtSakura2024,
  },
  {
    path: '/activity/m/sakura2024',
    component: HmtMSakura2024,
  },
  {
    path: '/activity/new-group-reservation-newyear',
    component: NewGroupReservation3,
  },
  {
    path: '/authcallback',
    component: lazy(() => import('@/pages/hmt/authcallback')),
    exact: true,
  },

  {
    path: '/activity/anniversary/:vroleid',
    component: HmtAnniversary2023FirstHalf,
  },
  // {
  //   path: '/pc-site/1st-anniversary',
  //   component: HmtFirstAnniversary,
  // },
  {
    path: '/activity/radiant',
    component: Radiant,
  },
  {
    path: '/pc-site/guildhall',
    component: lazy(() => import('@/pages/hmt/base-layout')),
    routes: [
      {
        path: '/pc-site/guildhall',
        component: Guild,
        exact: true,
      },
    ],
  },
  {
    path: '/m-site/guildhall',
    component: lazy(() => import('@/pages/hmt/base-layout')),
    routes: [
      {
        path: '/m-site/guildhall',
        component: Guild,
        exact: true,
      },
    ],
  },

  {
    path: '/pc-site/official',
    component: OfficialLayout,
    routes: [
      {
        path: '/pc-site/official',
        exact: true,
        render: () => (
          <Redirect
            to={`${routerIntercepterEnabled && isBefore909()
                ? '/pc-site/home' // 901 ~ 909
                : '/pc-site/official/home' // > 909
              }`}
          />
        ),
      },
      {
        path: '/pc-site/official/home',
        component: lazy(() => import('@/pages/hmt/official/pc-site')),
        isHide: routerIntercepterEnabled && isBefore909(),
      },
      {
        path: '/pc-site/official/endorse',
        component: lazy(() => import('@/pages/hmt/official/pc-site/endorse')),
        // isHide: routerIntercepterEnabled && isBefore901(),
      },
      {
        path: '/pc-site/official/news',
        component: lazy(
          () => import('@/pages/hmt/official/pc-site/subpages/news-home')
        ),
        exact: true,
        isHide: routerIntercepterEnabled && isBefore909(),
      },
      {
        path: '/pc-site/official/news-search',
        component: lazy(
          () =>
            import(
              '@/pages/hmt/official/pc-site/subpages/news-home/serach-index'
            )
        ),
        exact: true,
        isHide: routerIntercepterEnabled && isBefore909(),
      },
      {
        path: '/pc-site/official/news/:id',
        component: lazy(
          () => import('@/pages/hmt/official/pc-site/subpages/news-detail')
        ),
        exact: true,
        isHide: routerIntercepterEnabled && isBefore909(),
      },
      {
        // windows 公告 webview
        path: '/pc-site/official/webview/news/list',
        component: lazy(
          () =>
            import('@/pages/hmt/official/pc-site/subpages/news-list-webview')
        ),
        exact: true,
      },
      {
        // windows 启动器直播页面
        path: '/pc-site/official/webview/live',
        component: lazy(
          () => import('@/pages/hmt/official/pc-site/subpages/webview-live')
        ),
        exact: true,
      },
      // 落地页
      {
        path: '/pc-site/official/ads',
        component: lazy(() => import('@/pages/hmt/pc-ads')),
        routes: [
          {
            // pc 落地页1
            path: '/pc-site/official/ads',
            exact: true,
            render: () => <Redirect to="/pc-site/official/ads/pc-ads1" />,
          },
          {
            // pc 落地页1
            path: '/pc-site/official/ads/pc-ads1',
            component: PcAds1,
            exact: true,
          },
          {
            // pc 落地页2
            path: '/pc-site/official/ads/pc-ads2',
            component: PcAds2,
            exact: true,
          },
          {
            // pc 落地页3
            path: '/pc-site/official/ads/pc-ads3',
            component: PcAds3,
            exact: true,
          },
        ],
      },
      {
        path: '/pc-site/official/ads_h1',
        component: lazy(() => import('@/pages/hmt/pc-ads/ads-h1')),
        routes: [
          {
            // pc 落地页1
            path: '/pc-site/official/ads_h1',
            exact: true,
            render: () => <Redirect to="/pc-site/official/ads_h1/pc-ads1" />,
          },
          {
            // pc 落地页1
            path: '/pc-site/official/ads_h1/pc-ads1',
            component: PcAds1,
            exact: true,
          },
          {
            // pc 落地页2
            path: '/pc-site/official/ads_h1/pc-ads2',
            component: PcAds2,
            exact: true,
          },
          {
            // pc 落地页3
            path: '/pc-site/official/ads_h1/pc-ads3',
            component: PcAds3,
            exact: true,
          },
        ],
      },
      {
        path: '/pc-site/official/ads_h2',
        component: lazy(() => import('@/pages/hmt/pc-ads/ads-h2')),
        routes: [
          {
            // pc 落地页1
            path: '/pc-site/official/ads_h2',
            exact: true,
            render: () => <Redirect to="/pc-site/official/ads_h2/pc-ads1" />,
          },
          {
            // pc 落地页1
            path: '/pc-site/official/ads_h2/pc-ads1',
            component: PcAds1,
            exact: true,
          },
          {
            // pc 落地页2
            path: '/pc-site/official/ads_h2/pc-ads2',
            component: PcAds2,
            exact: true,
          },
          {
            // pc 落地页3
            path: '/pc-site/official/ads_h2/pc-ads3',
            component: PcAds3,
            exact: true,
          },
        ],
      },
      {
        path: '*',
        render: () => (
          <Redirect
            to={`${isBefore909()
                ? '/pc-site/home' // 901 ~ 909
                : '/pc-site/official/home' // > 909
              }`}
          />
        ),
      },
    ].filter((item) => !item.isHide),
  },
  {
    path: '/odin',
    component: lazy(() => import('@/pages/hmt/odin')),
  },
  {
    path: '/m-site/official',
    component: OfficialLayout,
    routes: [
      {
        path: '/m-site/official',
        exact: true,
        render: () => (
          <Redirect
            to={`${routerIntercepterEnabled && isBefore909()
                ? '/m-site/home' // 901 ~ 909
                : '/m-site/official/home' // > 909
              }`}
          />
        ),
      },
      {
        path: '/m-site/official/home',
        component: lazy(() => import('@/pages/hmt/official/m-site')),
        isHide: routerIntercepterEnabled && isBefore909(),
      },
      {
        path: '/m-site/official/endorse',
        component: lazy(() => import('@/pages/hmt/official/m-site/endorse')),
        // isHide: routerIntercepterEnabled && isBefore901(),
      },
      {
        path: '/m-site/official/news',
        component: lazy(
          () => import('@/pages/hmt/official/m-site/subpages/news-home')
        ),
        exact: true,
        isHide: routerIntercepterEnabled && isBefore909(),
      },
      {
        path: '/m-site/official/news-search',
        component: lazy(
          () =>
            import(
              '@/pages/hmt/official/m-site/subpages/news-home/search-index'
            )
        ),
        exact: true,
        isHide: routerIntercepterEnabled && isBefore909(),
      },
      {
        path: '/m-site/official/news/:id',
        component: lazy(
          () => import('@/pages/hmt/official/m-site/subpages/news-detail')
        ),
        exact: true,
        isHide: routerIntercepterEnabled && isBefore909(),
      },
      {
        path: '*',
        render: () => (
          <Redirect
            to={`${isBefore909()
                ? '/m-site/home' // 901 ~ 909
                : '/m-site/official/home' // > 909
              }`}
          />
        ),
      },
    ].filter((item) => !item.isHide),
  },
  ...ReservationV2Routes,

  /* 預約 915下線 */
  isBefore915()
    ? {
      path: '/pc-site',
      component: ReservationLayout,
      routes: [
        {
          path: '/pc-site',
          exact: true,
          render: () => <Redirect to="/pc-site/home" />,
        },
        {
          path: '/pc-site/home',
          component: lazy(
            () => import('@/pages/hmt/reservation/official-site/index')
          ),
        },
        {
          path: '/pc-site/share/:currentSlide?',
          component: lazy(
            () => import('@/pages/hmt/reservation/official-site/share')
          ),
        },
        {
          path: '/pc-site/personal',
          component: lazy(
            () => import('@/pages/hmt/reservation/official-site/personal')
          ),
        },
      ],
    }
    : {},
  isBefore915()
    ? {
      path: '/m-site',
      component: ReservationLayout,
      routes: [
        {
          path: '/m-site',
          exact: true,
          render: () => <Redirect to="/m-site/home" />,
        },
        {
          path: '/m-site/home',
          component: lazy(
            () => import('@/pages/hmt/reservation/m-site/index')
          ),
        },
        {
          path: '/m-site/share',
          component: lazy(
            () => import('@/pages/hmt/reservation/m-site/share')
          ),
        },
        {
          path: '/m-site/personal',
          component: lazy(
            () => import('@/pages/hmt/reservation/m-site/personal')
          ),
        },
      ],
    }
    : {},
  {
    path: '*',
    render: () => <Redirect to="/pc-site/official/home" />,
  },
].filter((item) => item.path)
// return routes
//   })
//   .catch((e) => {
//     console.error(e)
//     return Promise.resolve([] as RouteConfig[])
//   })

// export default generateRouter
export default routes
